import { render } from "./EmergingPractices.vue?vue&type=template&id=d31e77cc"
import script from "./EmergingPractices.vue?vue&type=script&lang=js"
export * from "./EmergingPractices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__